import styled from '@emotion/styled';
import { Box, Text } from '@opendoor/bricks-next';

import { EntryComponent } from '../../cms/entries/entries';
import { IComponentQuotes } from '../../declarations/contentful';

const Blockquote = styled.blockquote`
  margin: 0;
  position: relative;

  p::before {
    content: '“';
    display: inline-block;
    position: absolute;
    right: calc(100% + 16px);
  }
`;

const renderQuote = (entry: IComponentQuotes) => {
  const { fields } = entry;
  return (
    <Box p="$16x" $platform-web={{ gridColumn: '5 / -2' }}>
      <Blockquote>
        <Text tag="p" typography="$headerMedium">
          {fields.content}
        </Text>
      </Blockquote>
    </Box>
  );
};

const Quote: EntryComponent<IComponentQuotes> = {
  render: renderQuote,
};

export default Quote;
